import { getModel } from "core-web/state";
import { hashString } from "core-web/utils/hashString";
import DataLayer from "./DataLayer";

export default async ({ basketId, item, eventId }) => {
    if (!item) {
        return;
    }

    const userEmail = getModel("user").email?.toLowerCase();
    const hashedEmailSHA256 = await hashString(userEmail, "SHA-256");

    DataLayer.track({
        event: "add_to_cart",
        ecommerce: {
            basket: { id: basketId },
            add: {
                products: [DataLayer.getProduct(item)],
            },
        },
        eventId,
        hashedEmailSHA256,
    });
};
